import { SetSignatureComponent } from './set-signature/set-signature.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ListAccountsComponent } from './list-accounts/list-accounts.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { PrefsGoalsComponent } from './prefs-goals/prefs-goals.component';
import { PrefsPipelineComponent } from './prefs-pipeline/prefs-pipeline.component';
import { ChangeTimezoneComponent } from './change-timezone/change-timezone.component';
import { UpdatePersonalInfoComponent } from './update-personal-info/update-personal-info.component';
import { BillingInformationComponent } from './billing-information/billing-information.component';
import { ZohoSyncComponent } from './zoho-sync/zoho-sync.component';
import { SetVariablesComponent } from './set-variables/set-variables.component';
import { BccManageComponent } from './bcc-manage/bcc-manage.component';
import { ViewRepresentativesComponent } from './view-representatives/view-representatives.component';
import { InboxManagementComponent } from './inbox-management/inbox-management.component';
import { ManagerGuard } from '../shared/guards/manager.guard';
import { RoleGuard } from '../shared/guards/role.guard';
import { UserType } from '../store/models/user.model';
import { SetSmsDetailsComponent } from './set-sms-details/set-sms-details.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { ApiKeysComponent } from './api-keys/api-keys.component';
import { ApiKeysFeatureGuard } from '../shared/guards/api-keys-feature.guard';

const routes: Routes = [
  {
    path: 'accounts',
    component: AuthenticatedComponent,
    children: [
      {
        path: 'set_signature',
        canActivate: [AuthGuard],
        component: SetSignatureComponent,
      },
      {
        path: '',
        canActivate: [RoleGuard],
        component: ListAccountsComponent,
        data: {
          roles: [UserType.MASTER, UserType.PARTNER, UserType.FRANCHISE],
        },
      },
      {
        path: 'new',
        canActivate: [AuthGuard],
        component: CreateAccountComponent,
      },
      {
        path: 'change_password',
        canActivate: [AuthGuard],
        component: ChangePasswordComponent,
      },
      {
        path: 'api_keys',
        canActivate: [AuthGuard, ApiKeysFeatureGuard],
        component: ApiKeysComponent,
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        component: AccountSettingsComponent,
      },
      {
        path: 'prefs_goals',
        canActivate: [AuthGuard],
        component: PrefsGoalsComponent,
      },
      {
        path: 'prefs_pipeline',
        canActivate: [AuthGuard],
        component: PrefsPipelineComponent,
      },
      {
        path: 'change_timezone',
        canActivate: [AuthGuard],
        component: ChangeTimezoneComponent,
      },
      {
        path: 'update_personal_info',
        canActivate: [AuthGuard],
        component: UpdatePersonalInfoComponent,
      },
      {
        path: 'update_credit_card',
        canActivate: [AuthGuard],
        component: BillingInformationComponent,
      },
      {
        path: 'zoho_sync',
        canActivate: [AuthGuard],
        component: ZohoSyncComponent,
      },
      {
        path: 'set_variables',
        canActivate: [AuthGuard],
        component: SetVariablesComponent,
      },
      {
        path: 'view_representatives',
        canActivate: [ManagerGuard],
        component: ViewRepresentativesComponent,
      },
      {
        path: 'inbox_management',
        canActivate: [RoleGuard],
        component: InboxManagementComponent,
        data: {
          roles: [UserType.MASTER, UserType.SINGLE_USER],
        },
      },
      {
        path: 'set_sms_details',
        canActivate: [RoleGuard],
        component: SetSmsDetailsComponent,
        data: {
          roles: [UserType.SINGLE_USER, UserType.MANAGER],
        },
      },
      {
        path: 'integrations/:id',
        canActivate: [AuthGuard],
        component: IntegrationsComponent,
      },
      {
        path: 'invoices',
        loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule),
      },
      {
        path: 'bcc-manage',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'all',
            canActivate: [AuthGuard],
            component: BccManageComponent,
            data: {
              type: 'all',
            },
          },
          {
            path: 'meeting',
            canActivate: [AuthGuard],
            component: BccManageComponent,
            data: {
              type: 'meeting',
            },
          },
          {
            path: 'followup',
            canActivate: [AuthGuard],
            component: BccManageComponent,
            data: {
              type: 'followup',
            },
          },
          {
            path: 'cycle',
            canActivate: [AuthGuard],
            component: BccManageComponent,
            data: {
              type: 'cycle',
            },
          },
          {
            path: 'remove',
            canActivate: [AuthGuard],
            component: BccManageComponent,
            data: {
              type: 'remove',
            },
          },
          {
            path: 'inactive',
            canActivate: [AuthGuard],
            component: BccManageComponent,
            data: {
              type: 'inactive',
            },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountsRoutingModule {
}
